// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"8854":"6b23f077445ba0ab","9626":"8f05979eb470c9ff"}[chunkId] + ".js";
};